import SinglePublicationVideoContent from './SinglePublicationVideoContent';
export default SinglePublicationVideoContent;
